import { isEqual as isEqualFns } from 'date-fns';

export default function isEqual(date: Date, dateToCompareTo: Date): boolean {
  return isEqualFns(date, dateToCompareTo);
}
